import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useEffect } from "react";
import LockIcon from "@/assets/images/lock.png";
import { Button, Container, Typography } from "@/components/atoms";
import { GeneralFooter, GeneralHeader } from "@/components/organisms";
import { useLayout } from "@/hooks";
import { useAppResetApi } from "@/redux/hooks";
import { clsx } from "@/utils";

export const Suspended = ({ className }: React.HTMLAttributes<HTMLDivElement>) => {
  const { setFullScreen } = useLayout();
  const resetApi = useAppResetApi();
  const { logout } = useKindeAuth();

  useEffect(() => {
    setFullScreen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = () => {
    // Clear API cache
    resetApi();
    // Trigger Kinde logout
    logout();
  };

  return (
    <div className="flex min-h-screen flex-row overflow-hidden">
      <div className="relative flex flex-1 flex-col">
        <GeneralHeader isPrivateContent />
        <div className={clsx("flex flex-1 flex-row bg-contain bg-[center_bottom_-2rem] bg-no-repeat", className)}>
          <Container className="flex max-w-md flex-col items-center px-5 pb-32 pt-[14vh]">
            <img src={LockIcon} alt="Restricted Access" className="max-w-[128px]" />
            <Typography variant="title" className="mb-4 text-center !text-[24px] sm:!text-[32px]">
              This account has been suspended
            </Typography>
            <Typography variant="paragraph" className="text-center text-neutral-dark-gray">
              Please contact support@rideminder.com if you are the owner of the account.
            </Typography>
            <Button onClick={handleLogout} className="mt-8" size="lg">
              Logout
            </Button>
          </Container>
          <div className="pointer-events-none fixed bottom-0 min-h-[50%] w-full bg-city bg-cover bg-no-repeat" />
        </div>
        <GeneralFooter />
      </div>
    </div>
  );
};
